module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "book-filter"
  }, [_c('h2', [_vm._v("Books Filter")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookFilter.byText),
      expression: "bookFilter.byText"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Filter By Name"
    },
    domProps: {
      "value": (_vm.bookFilter.byText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bookFilter.byText = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a5a20ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/books/BookFilter.vue
// module id = 288
// module chunks = 1